<div class="operator-sign-status" [ngClass]="getStatusClass()">
    <div class="status-indicator">
        <span class="status-dot"></span>
        <span class="status-text">{{ getStatusText() }}</span>
    </div>

    <button
        type="button"
        class="btn-recheck"
        (click)="recheckStatus()"
        [disabled]="isManualChecking"
        title="Verifică din nou statusul serviciului">
        <i class="fa-solid fa-rotate" [class.fa-spin]="isManualChecking"></i>
    </button>
</div>
